import React, { useRef, useContext, useState, useEffect } from "react";
import { ASSETS_URL } from "../../components/Store";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Mousewheel, Navigation, Pagination } from "swiper";
import { memo } from "react";
import { Book } from "../../components/shared/book";
import { store } from "../../components/Store";
import { useHistory } from "react-router-dom";
import { useFavoritesManager } from "../../hooks/use-favorites-manager";

/**
 * Componente de sección de libros.
 * @param {Object} props - Props del componente.
 * @param {Array} props.books - Libros para mostrar.
 * @param {number} props.autoPlayDelay - Retraso de reproducción automática de los libros.
 * @param {Object} props.navigationButtons - Referencias a los botones de navegación.
 * @returns {JSX.Element} Elemento JSX que representa la sección de libros.
 */
export const BooksSectionCollection = memo(({ books, autoPlayDelay, navigationButtons }) => {
    const swiperRef = useRef(null);
    books = Array.isArray(books) ? books : [];
    const globalState = useContext(store);
    const isAuthenticatedUser = globalState?.state?.sesionActiva === 'SI';
    const user = globalState.state.username;
    const favoritesManager = useFavoritesManager();
    const favorites = favoritesManager?.favoriteBooks;

    const history = useHistory();

    const updateNavigation = (swiper)=>{
        swiper.params.navigation.prevEl = navigationButtons?.prevButtonRef?.current
        swiper.params.navigation.nextEl = navigationButtons?.nextButtonRef?.current
        swiper.navigation.destroy()
        swiper.navigation.init()
        swiper.navigation.update()
    }

    const [isMobile, setIsMobile] = useState(window.innerWidth < 768 ? true : false);

    useEffect(() => {
        const setMobile = () => {
            let validacion;
            if (window.innerWidth < 768) {
                validacion = true;
            } else {
                validacion = false;
            }
            setIsMobile(validacion)
        }
        setMobile();
        window.addEventListener('resize', setMobile)
        return () => {
            window.removeEventListener('resize', setMobile)
        }
    }, [])

    return (
        <section className="mt-3">
            <div className="relative">
                <Swiper
                    ref={swiperRef}
                    className="main-covers pb-5"
                    style={{ overflowX: 'hidden' }}
                    slidesPerGroup={2}
                    slidesPerView={2}
                    spaceBetween={0}
                    breakpoints={{
                        510: {
                            slidesPerView: 3,
                            slidesPerGroup: 3,
                        },
                        578: {
                            slidesPerView: 4,
                            slidesPerGroup: 4,
                        },
                        726: {
                            slidesPerView: 5,
                            slidesPerGroup: 5,
                        },
                        886: {
                            slidesPerView: 6,
                            slidesPerGroup: 6,
                        },
                        1100: {
                            slidesPerView: 7,
                            slidesPerGroup: 7,
                        },
                        1272: {
                            slidesPerView: 8,
                            slidesPerGroup: 8,
                        },
                        1400: {
                            slidesPerView: 9,
                            slidesPerGroup: 9,
                        },
                        1600: {
                            slidesPerView: 10,
                            slidesPerGroup: 10,
                        },
                        1700: {
                            slidesPerView: 11,
                            slidesPerGroup: 11,
                        },
                        1900: {
                            slidesPerView: 12,
                            slidesPerGroup: 12,
                        },
                    }}
                    autoplay={{
                        delay: autoPlayDelay || 5000,
                        disableOnInteraction: false,
                    }}
                    mousewheel={{
                        forceToAxis: true,
                    }}
                    navigation={{
                        nextEl: navigationButtons?.nextButtonRef?.current,
                        prevEl: navigationButtons?.prevButtonRef?.current,
                    }}
                    onSwiper={(swiper) => {
                        updateNavigation(swiper);
                    }}
                    pagination={{
                        clickable: isMobile ? true : false,
                        enabled: isMobile ? true : false,
                    }}
                    modules={[Autoplay, Navigation, Mousewheel, Pagination]}
                >
                    {books.map((book, i) => {
                        return (
                            <SwiperSlide
                                className="focusable-by-children-secondary d-flex justify-content-center"
                                key={`banner${i}`}
                            >
                                <Book
                                    libro={{
                                        ...book,
                                        portada: `${ASSETS_URL}${book?.url}`,
                                        title: book?.nombreLibro
                                    }}
                                    alSeleccionar={() => history.push(book?.link)}
                                    ocultarOpciones={{
                                        checkbox: true,
                                        bookType: false,
                                        botonFavoritos: isAuthenticatedUser ? false : true
                                    }}

                                    clasesPersonalizadas={{
                                        contenedor: ''
                                    }}
                                    alAgregarFav={(item) => favoritesManager.add({ bookId: item?.idLibro })}
                                    alRemoverFav={(item) => favoritesManager.remove({ bookId: item?.idLibro })}
                                    estadoInicial={{
                                        esFavorito: favorites.some(fav => fav?.idLibro === book?.idLibro),
                                    }}
                                />
                            </SwiperSlide>
                        );
                    })}
                </Swiper>
            </div>
        </section>
    );
});